import React from 'react'
import { ButtonContainer } from './styles'
import { IconComponent } from '~/assets/icons/component'
import { message } from '~/services'

interface ShowFeedbackButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isCollapsed: boolean
}

export const ShowFeedbackButton = ({ isCollapsed, ...rest }: ShowFeedbackButtonProps): JSX.Element => {
  return (
    <ButtonContainer isCollapsed={isCollapsed} {...rest}>
      <IconComponent name="feedback" />
      <span>{message('feedback.help_us')}</span>
    </ButtonContainer>
  )
}
